import { IDataState, IDataAction } from "../state.types";
import { SET_CEDULA_TYPE, SET_PETITION_FORM } from "../actions.consts";
import { setCedulaType, setStatusServer } from "./data.actions";

const initialState = { typeCedula: [], getStatusServer: [] } as IDataState;

export const dataReducer = (
  state: IDataState = initialState,
  action: IDataAction
) => {
  switch (action.type) {
    case SET_CEDULA_TYPE:
      return setCedulaType(state, action.payload);
    case SET_PETITION_FORM:
      return setStatusServer(state, action.payload);
    default:
      return state;
  }
};
